import axios from 'axios';
import { encode64 } from './ebUtils';

export const orgId = window.location.pathname.replace(/^\/(\d+)(\/.*)?$/, '$1')
export const commsId = window.location.pathname.replace(/^\/comms\/(.+)$/, '$1')
export const redirectToLogin = () => (window.location.href = `/${orgId}/login`);
window.sharedRedirectToLogin = redirectToLogin;
export const redirectToLoginWithOrigin = (originUrl) => {
  window.location.href = `/${orgId}/login?origin=${originUrl}`;
};
window.sharedRedirectToLoginWithOrigin = redirectToLoginWithOrigin;

export const ajaxLoadingSubscriptions = {
  show() {
    const ajaxLoadingSubscriptionsElement = document.getElementById('sspAjaxLoadingSubscriptions');
    if (!ajaxLoadingSubscriptionsElement) return;
    ajaxLoadingSubscriptionsElement.style.display = 'block';
  },
  hide() {
    const ajaxLoadingSubscriptionsElement = document.getElementById('sspAjaxLoadingSubscriptions');
    if (!ajaxLoadingSubscriptionsElement) return;
    ajaxLoadingSubscriptionsElement.style.display = 'none';
  },
};

export const ajaxLoading = {
  show() {
    const ajaxLoadingElement = document.getElementById('sspAjaxLoading');
    if (!ajaxLoadingElement) return;
    ajaxLoadingElement.style.display = 'block';
  },
  hide() {
    const ajaxLoadingElement = document.getElementById('sspAjaxLoading');
    if (!ajaxLoadingElement) return;
    ajaxLoadingElement.style.display = 'none';
  },
};

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const { CancelToken } = axios;
const defaultHeaders = [];

const XHRRequest = async ({ base64required, isSignUp, headers, ...params }) => {
  try {
    ajaxLoading.show();

    const options =
      base64required && params.data
        ? {
          data: encode64(JSON.stringify(params.data)),
          headers: {
            ...defaultHeaders,
            ...headers,
            'Encode-Type': 'eb-base64',
            'Content-Type': 'application/javascript; charset=utf-8',
          },
          ...params,
        }
        : {
          headers: {
            ...defaultHeaders,
            ...headers,
          },
          ...params,
        };

    const res = await axios(options);

    ajaxLoading.hide();

    return { ...res };
  } catch (error) {
    const { response: { status, data } = {} } = error;

    if (!isSignUp) {
      switch (status) {
        case 401:
        case 504:
          redirectToLogin();
          break;
        default:
      }
    }

    ajaxLoading.hide();

    return { data, status, hasError: true, isCanceled: axios.isCancel(error) };
  }
};

export const Ajax = {
  CancelToken,
  SET_X_CSRF_TOKEN: (token) => {
    defaultHeaders['X-CSRF-TOKEN'] = token;
  },
  get: (url, options) => XHRRequest({ url, ...options }),
  post: (url, data, options) => XHRRequest({ method: 'post', url, data, ...options }),
  put: (url, data, options) => XHRRequest({ method: 'put', url, data, ...options }),
  delete: (url, data, options) => XHRRequest({ method: 'delete', url, data, ...options }),
};
